export const locales = ['en', 'nl', 'fr', 'ja'] as const
export type Locale = (typeof locales)[number]

export const drupalLang =
	(process.env.NEXT_PUBLIC_DRUPAL_LANG as Locale) || locales[0]
